import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthAppUserDto, AuthDto } from '@lib/user/utils';
import { BaseResponse } from '@shared/utils/interfaces';
import { Observable } from 'rxjs';

import { authUrl, initUserAuthUrl, refreshAuthUrl } from './user-api.constant';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  private readonly http = inject(HttpClient);

  loginViaAuth(authCode: string, redirectUri: string): Observable<BaseResponse<AuthDto>> {
    return this.http.post<BaseResponse<AuthDto>>(authUrl(), { authCode, redirectUri });
  }

  refreshToken(refreshToken: string): Observable<BaseResponse<AuthDto>> {
    return this.http.post<BaseResponse<AuthDto>>(refreshAuthUrl(), { refreshToken });
  }

  initUserViaAuth(): Observable<BaseResponse<AuthAppUserDto>> {
    return this.http.get<BaseResponse<AuthAppUserDto>>(initUserAuthUrl());
  }

  updateUserViaAuth(userInfo: Partial<AuthAppUserDto>): Observable<void> {
    return this.http.patch<void>(initUserAuthUrl(), userInfo);
  }
}
